import React, { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { checkRefreshTokenExpiration } from "../utils/token-utils";
import { logout } from "../actions/auth";

/**
 * Componente que muestra avisos de expiración de sesión
 * Verifica periódicamente si el refresh token está próximo a expirar
 */
const SessionExpirationWarning = ({ userApi }) => {
  const [expirationStatus, setExpirationStatus] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkExpiration = () => {
      const status = checkRefreshTokenExpiration();
      setExpirationStatus(status);

      if (status?.expired) {
        // Si el refresh token ya expiró, hacer logout automático
        dispatch(logout(userApi));
      }
    };

    // Verificar inmediatamente
    checkExpiration();

    // Verificar cada hora
    const interval = setInterval(checkExpiration, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [userApi, dispatch]);

  if (!expirationStatus) {
    return null;
  }

  if (expirationStatus.warning) {
    return (
      <Alert variant="warning" className="m-3">
        <Alert.Heading>Aviso de Sesión</Alert.Heading>
        <p>{expirationStatus.message}</p>
      </Alert>
    );
  }

  return null;
};

SessionExpirationWarning.propTypes = {
  userApi: PropTypes.object
};

export default SessionExpirationWarning;
